module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"status":"Alle Macro-Trends bewertet|{cnt} Macro-Trend zu bewerten|{cnt} Macro-Trends zu bewerten"},"en":{"status":"All macro-trends rated|Rate {cnt} macro-trend|Rate {cnt} macro-trends"}}')
  delete Component.options._Ctor
}
